export const VossPeriodAnchor = {
    LatestPeriod: 0,
    CurrentPeriod: 1
}